import { isJWT } from 'class-validator';

export const isValidDate = (date: any) => !isNaN(date) && date instanceof Date;

// from https://stackoverflow.com/questions/51292406/jwt-check-if-token-expired
export const isValidToken = (token: string | null | undefined) => {
  if (!token) return false;
  return (
    isJWT(token) &&
    Date.now() <= JSON.parse(atob(token.split('.')[1])).exp * 1000
  );
};
